import type { ConstValues } from '@openx/types/helpers';

export const dateRangeFormFields = {
  START_DATE: 'date-range-picker-start-date',
  END_DATE: 'date-range-picker-end-date',
} as const;
export type DateRangeFormFields = ConstValues<typeof dateRangeFormFields>;
